import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import App from './App';
import "./i18n";
import store from './redux/store';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleReCaptchaProvider reCaptchaKey="6LdCHzcrAAAAALUKBE7_HwiPSjnlehNPTEnEmIrX">
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </GoogleReCaptchaProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
